import React, { useContext, useState } from 'react';
import { Column } from '@codeparva/ui-components-library';
import { Formik } from 'formik';
import { UpdatePaymentDetailsTypes } from '../../UpdatePaymentDetailsTypes';
import { fetchCardProcessorAuthKeyToken } from '../../helpers/apiHelpers';
import { PaymentContext } from '../../../../components/syrapayHostedForm/context/PaymentContext';
import { UpdatePaymentDetailsForm } from '../Form/UpdatePaymentDetailsForm';
import { formLabels } from '../../constants/accountPanelConfigs';

export const UpdatePaymentDetails = ({
  callBackHandler,
  cardDetails,
  paymentMethod,
  cardProcessorId,
  facilityId,
  tenantToken,
}: UpdatePaymentDetailsTypes.TUpdatePaymentForm) => {
  const [authKey, setAuthKey] = useState<any>();
  const [shouldShowHostedForm, setShouldShowHostedForm] = useState<boolean>(
    false
  );
  const [disabled, setDisabled] = useState<boolean>(false);
  const paymentContext = useContext(PaymentContext);
  const { existingCardInfoLabel } = formLabels;

  const defaultBillingInfo = {
    address: {
      line1: 'N/A',
      zip_code: 'N/A',
    },
    name: 'N/A',
  };

  const {
    name,
    address: { line1, zip_code },
  } = cardDetails?.billing_info ?? defaultBillingInfo;

  const cardNumberFormatter = (cardNumber: string) => {
    const cardNumberWithStarts = cardNumber.includes('X')
      ? cardNumber
      : cardNumber.replaceAll('*', 'X');
    return cardNumberWithStarts
      .split('-')
      .join('')
      .match(new RegExp('.{1,4}', 'g'))
      ?.join(' - ');
  };

  const initialValues = {
    cardNumber: cardDetails?.masked_card_number
      ? cardNumberFormatter(cardDetails.masked_card_number)
      : '',
    expiryDate: cardDetails?.expiration_date?.month
      ? `${cardDetails.expiration_date.month} / ${cardDetails.expiration_date.year}`
      : '',
    cvv: '****',
    holderName: name,
    address: line1,
    postalCode: zip_code,
  };

  const formProps = {
    disable: disabled,
    shouldShowHostedForm,
    setShouldShowHostedForm,
    setDisabled,
    authKey,
    callBackHandler,
    paymentMethod,
    cardProcessorId,
  };

  return (
    <>
      <Column className="updatePaymentDetailsParentSection">
        <Formik
          initialValues={initialValues}
          onSubmit={async (_values, { setSubmitting }) => {
            setDisabled(true);
            setSubmitting(false);
            const [
              ,
              { data: { data = {} } = {} } = {},
            ] = await fetchCardProcessorAuthKeyToken(
              cardProcessorId,
              facilityId,
              tenantToken
            );
            setAuthKey(data.authenticationKey);
            paymentContext?.setAuthenticationKey(data.authenticationKey);
            setShouldShowHostedForm(true);
          }}
        >
          <>
            <h5 className="pb-5">{existingCardInfoLabel}</h5>
            <UpdatePaymentDetailsForm {...formProps} />
          </>
        </Formik>
      </Column>
    </>
  );
};
